var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgItemRemove = function SvgItemRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.385 8 .615.615L12.615 12 16 15.385l-.615.615L12 12.615 8.615 16 8 15.385 11.384 12 8 8.615 8.615 8 12 11.385 15.385 8Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgItemRemove;